import { Heading, VStack } from '@chakra-ui/react';
import { FC, useContext } from 'react';
import EntityContext from '../../../context/EntityContext';
import { ParagraphActivityPoiNearActivitiesFragment } from '../../../generated/types';
import { useStore } from '../../../store/provider';
import getAppComponent from '../../../utils/getAppComponent';
import TeaserGrid from '../../Common/TeaserGrid';

interface ActivityPoiNearActivitiesProps {
  data: ParagraphActivityPoiNearActivitiesFragment;
}

export const ActivityPoiNearActivities: FC<ActivityPoiNearActivitiesProps> = ({
  data,
}) => {
  const entityContext = useContext(EntityContext);
  const store = useStore();

  if (!('nearActivities' in entityContext.entity)) {
    return null;
  }

  const TeaserComponent = getAppComponent(
    process.env.APP_ID!,
    store.config.usesNewLayout,
    'ActivityTeaser'
  );

  if (!entityContext.entity.nearActivities.total) {
    return null;
  }

  return (
    <>
      {data.title && (
        <Heading mb={2} fontSize="2xl">
          {data.title}
        </Heading>
      )}
      <TeaserGrid columns={1} spacing={8}>
        {entityContext.entity.nearActivities.items.map((activity) => {
          return (
            <TeaserComponent
              key={activity!.id}
              data={activity}
              imageContainerMaxWidth="320px"
              noOfLines={{
                base: 3,
                md: 3,
              }}
              hideCTA
            />
          );
        })}
      </TeaserGrid>
    </>
  );
};

export default ActivityPoiNearActivities;
